var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.759,
    height: 41,
    viewBox: "0 0 25.759 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#388ac8;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(3 5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.1,30.669a12.842,12.842,0,0,1,12.121,8.541,13.872,13.872,0,0,1,.1,8.588,60.841,60.841,0,0,1-4.836,11.7c-2.059,4.016-4.363,7.89-6.8,11.685-.411.639-.695.642-1.142.014a94.275,94.275,0,0,1-8.791-14.825,38.3,38.3,0,0,1-3.317-10.011,14.227,14.227,0,0,1,.278-6.438,12.689,12.689,0,0,1,5.37-7.2A12.473,12.473,0,0,1,159.1,30.669Zm-5.977,13.124a5.959,5.959,0,1,0,5.966-5.93A5.963,5.963,0,0,0,153.121,43.793Z",
    transform: "translate(-146.19 -30.669)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/LocationMarker.8f1c5558d148356e104840acb9a69dbc.svg";
export { ForwardRef as ReactComponent };